/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_New_ButtonInputs */

const vi_stocktake_new_button = /** @type {(inputs: Stocktake_New_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu kiểm`)
};

/**

* @param {Stocktake_New_ButtonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_new_button = /** @type {((inputs?: Stocktake_New_ButtonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_New_ButtonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_new_button(inputs)
});